const hasValue = (value) => typeof value === "string" && value.trim() !== "";

const requireValue = (value, field) => {
    if (!hasValue(value)) {
        throw new Error(`${field} is required`);
    }
    return value.trim();
};

const requireConsent = ({ agreementAccepted, privacyAccepted }) => {
    if (agreementAccepted !== true || privacyAccepted !== true) {
        throw new Error("user agreement and privacy policy must be accepted");
    }
    return { agreementAccepted: true, privacyAccepted: true };
};

const buildLoginPayload = (input = {}) => {
    const hasPassword = hasValue(input.password);
    const hasSmsCode = hasValue(input.smsCode);

    if (hasPassword === hasSmsCode) {
        throw new Error("exactly one login credential is required");
    }

    return {
        phone: requireValue(input.phone, "phone"),
        ...(hasPassword
            ? { password: input.password }
            : { smsCode: requireValue(input.smsCode, "smsCode") }),
        autoLogin: input.autoLogin === true,
        ...requireConsent(input),
    };
};

const buildRegistrationPayload = (input = {}) => {
    const nickname = hasValue(input.nickname) ? input.nickname.trim() : null;
    const inviteCode = hasValue(input.inviteCode) ? input.inviteCode.trim() : null;

    return {
        phone: requireValue(input.phone, "phone"),
        ...(nickname ? { nickname } : {}),
        password: requireValue(input.password, "password"),
        smsCode: requireValue(input.smsCode, "smsCode"),
        ...(inviteCode ? { inviteCode } : {}),
        ...requireConsent(input),
    };
};

const buildResetPasswordPayload = (input = {}) => ({
    phone: requireValue(input.phone, "phone"),
    newPassword: requireValue(input.newPassword, "newPassword"),
    smsCode: requireValue(input.smsCode, "smsCode"),
});

const buildChangePasswordPayload = (input = {}) => ({
    smsCode: requireValue(input.smsCode, "smsCode"),
    newPassword: requireValue(input.newPassword, "newPassword"),
});

module.exports = {
    buildLoginPayload,
    buildRegistrationPayload,
    buildResetPasswordPayload,
    buildChangePasswordPayload,
};
